/**
 * Generic interceptor allowing the instantiator to "tap" into the interceptor
 * chain in order to perform some non-mutating operation on the request and
 * response.
 */
export class TapRequestInterceptor {
    constructor(tap) {
        this.tap = tap;
    }
    intercept(request, next) {
        const response = next.handle(request);
        this.tap(request, response);
        return response;
    }
}
